@import '../../../../constants/spacing.module.less';
@import '../../../../app-brand/entities/entity-layer.module.less';
@import '../../../../constants/screen-width-breakpoints.module.less';

.toggler {
  color: @top-nav--button--text-color;
  font-size: 14px;
  padding: @space-8;
  border-radius: @space-4;

  display: flex;
  align-items: center;
  gap: @space-8;
  white-space: nowrap;

  &:hover,
  &:focus,
  &.open {
    color: @top-nav--button--hover--text-color;
    background-color: @top-nav--button--hover--background-color;
  }

  &:active {
    background-color: transparent;
  }

  img {
    width: 16px;
    height: 16px;
  }

  p {
    display: flex;
    align-items: center;

    gap: @space-4;

    font-weight: 500;
  }
  span {
    font-size: 12px;
    line-height: 16px;
  }
}

.popup {
  --card-background-color: var(--grey-900);
  --card-connected-color: var(--grey-400);

  position: fixed;
  top: 48px;
  right: 9px;
  z-index: 3;

  border: 1px solid var(--grey-800);
  border-radius: 8px;
  background-color: var(--grey-900);
  box-shadow: 0 4px 2px -2px rgba(0, 0, 0, 0.16);

  color: var(--white);
}

.banner-is-visible {
  top: 104px;
}

.popup-header {
  align-self: stretch;
  align-items: center;

  justify-content: space-between;

  padding: @space-24 @space-24 @space-16;

  .close-button {
    color: var(--grey-400);

    &:hover,
    &:focus {
      color: var(--grey-300);
      background-color: var(--blue-300-fade-30);
    }
  }

  .popup-link-button {
    color: var(--blue-400);

    &:hover,
    &:focus {
      color: var(--grey-300);
      background-color: var(--blue-300-fade-30);
    }
  }
}

.popup-body {
  padding: @space-12 @space-24 @space-32;
  overflow-y: scroll;
  scrollbar-width: none;
  @media @tablet-height {
    max-height: 536px;
  }

  @media @desktop-height {
    max-height: 736px;
  }
}

.popup-section {
  &:not(:last-of-type) {
    padding-bottom: @space-16;
    border-bottom: 1px solid var(--grey-800);
    margin-bottom: @space-16;
  }
}
